import React from 'react'

const Confirmed = () => {
  return (
    <div>Confirmed</div>
  )
}

export default Confirmed